import { Release } from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class ReleaseService extends CrudService {
  static override route = 'releases';

  async getReleases(params?: { since?: string }): Promise<Release[]> {
    try {
      const searchParams = new URLSearchParams();
      if (params?.since) {
        searchParams.set('since', params.since);
      }
      const query = searchParams.toString();
      const url = query ? `${this.path}?${query}` : this.path;
      const response = await this.httpService.get<BaseResponse<Release[]>>(url);
      return response.data;
    } catch (error) {
      console.error('Failed getting releases', error);
      throw error;
    }
  }

  async getReleaseById(id: string): Promise<Release | null> {
    try {
      const response = await this.httpService.get<BaseResponse<Release | null>>(
        `${this.path}/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error('Failed getting release by id', error);
      throw error;
    }
  }

  async recordViews(releaseIds: string[]): Promise<void> {
    await this.httpService.post<
      { releaseIds: string[] },
      BaseResponse<{ ok: boolean }>
    >(`${this.path}/views`, { releaseIds });
  }
}
